<h5 *ngIf="title">{{ title }}</h5>
<form
  [formGroup]="form"
  (submit)="onSubmit($event)"
  class="align-items-end form-width"
  [ngbTooltip]="form.disabled ? disableTooltip : ''"
>
  <div *ngIf="form">
    <div class="row no-gutters">
      <div class="col" [class.col-12]="fullRowInput">
        <div class="form-group">
          <div>
            <label class="form-control-label" [for]="value">{{
              leftFieldlabel
            }}</label>
            <select
              class="form-control"
              [formControl]="value"
              [id]="'select-order-' + valueToUpdate"
              (change)="selectChange($event?.target?.value)"
            >
              <option *ngFor="let option of options" [value]="option.value">
                {{ option.name }}
              </option>
            </select>
            <div
              *ngIf="
                value.invalid &&
                (value.dirty || value.touched) &&
                value.hasError('invalidChange')
              "
              class="form-control-feedback text-danger"
            >
              {{ value?.errors?.invalidChange }}
            </div>
          </div>
        </div>
      </div>
      <div class="col" [class.col-12]="fullRowInput">
        <div class="form-group">
          <div>
            <label
              class="form-control-label"
              [for]="'order-id-' + valueToUpdate"
              >Order number *</label
            >
            <input
              type="text"
              class="form-control"
              placeholder="Order number (16 alphanumeric characters)"
              [id]="'order-id-' + valueToUpdate"
              [formControl]="orderId"
            />
            <div
              class="form-control-feedback text-danger"
              *ngIf="orderId.invalid && (orderId.dirty || orderId.touched)"
            >
              <span *ngIf="orderId.hasError('required')">
                Order number is required
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-auto align-self-end">
        <app-button
          bsClass="primary"
          buttonType="submit"
          [id]="'submit-' + valueToUpdate"
          [disabled]="disabledSubmit || disabled"
          [tooltip]="!canPlaceOrders ? buttonTooltip : ''"
          [labeled]="true"
          [showLoader]="isUpdatingInput"
        >
          Save changes
        </app-button>
      </div>
      <div *ngIf="useCancelButton" class="col-auto">
        <button
          [id]="'cancel-' + valueToUpdate"
          class="btn btn-link"
          (click)="cancel($event)"
        >
          <i class="fas fa-times"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</form>
